<div class="time-picker-wrapper relative" [class]="styleClass">
  <div
    #triggerElement
    class="time-picker-trigger"
    [class.time-picker-trigger--disabled]="disabled"
    (click)="toggleDropdown($event)"
    role="button"
    [attr.aria-expanded]="isOpen"
    [attr.aria-haspopup]="'dialog'"
    [attr.tabindex]="disabled ? -1 : 0"
    (keydown.enter)="toggleDropdown($event)"
    (keydown.space)="$event.preventDefault(); toggleDropdown($event)"
  >
    <span class="time-picker-trigger__icon" aria-hidden="true">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </span>
    <span
      class="time-picker-trigger__value"
      [class.time-picker-trigger__value--placeholder]="!displayValue"
    >
      {{ displayValue || placeholder }}
    </span>
    <button
      *ngIf="displayValue && !disabled"
      type="button"
      class="time-picker-trigger__clear"
      aria-label="Clear time"
      (click)="onClearClick($event)"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <div
    #panelDropdown
    *ngIf="isOpen"
    class="time-picker-panel"
    role="dialog"
    aria-label="Select time"
    (click)="$event.stopPropagation()"
  >
    <div class="time-picker-panel__preview" aria-live="polite">
      <span class="time-picker-panel__preview-label">Selected time</span>
      <span class="time-picker-panel__preview-value">{{ previewTime }}</span>
    </div>

    <div class="time-picker-panel__steppers">
      <div class="time-picker-stepper">
        <span class="time-picker-stepper__label">Hour</span>
        <div class="time-picker-stepper__controls">
          <button
            type="button"
            class="time-picker-stepper__btn"
            aria-label="Decrease hour"
            [disabled]="!canDecrementHour"
            (click)="decrementHour()"
          >
            −
          </button>
          <input
            type="text"
            class="time-picker-stepper__input"
            inputmode="numeric"
            maxlength="2"
            aria-label="Hour"
            [value]="hourInput"
            (input)="onHourInput($event)"
            (blur)="onHourBlur()"
            (keydown.enter)="applyAndClose()"
          />
          <button type="button" class="time-picker-stepper__btn" aria-label="Increase hour" (click)="incrementHour()">
            +
          </button>
        </div>
      </div>
      <span class="time-picker-panel__colon" aria-hidden="true">:</span>
      <div class="time-picker-stepper">
        <span class="time-picker-stepper__label">Minute</span>
        <div class="time-picker-stepper__controls">
          <button
            type="button"
            class="time-picker-stepper__btn"
            aria-label="Decrease minute"
            [disabled]="!canDecrementMinute"
            (click)="decrementMinute()"
          >
            −
          </button>
          <input
            type="text"
            class="time-picker-stepper__input"
            inputmode="numeric"
            maxlength="2"
            aria-label="Minute"
            [value]="minuteInput"
            (input)="onMinuteInput($event)"
            (blur)="onMinuteBlur()"
            (keydown.enter)="applyAndClose()"
          />
          <button type="button" class="time-picker-stepper__btn" aria-label="Increase minute" (click)="incrementMinute()">
            +
          </button>
        </div>
      </div>
    </div>

    <div class="time-picker-panel__footer">
      <button type="button" class="time-picker__footer-btn time-picker__footer-btn--muted" (click)="clear()">
        Clear
      </button>
      <div class="time-picker-panel__footer-actions">
        <button type="button" class="time-picker__footer-btn time-picker__footer-btn--ghost" (click)="setNow()">
          Now
        </button>
        <button
          type="button"
          class="time-picker__footer-btn time-picker__footer-btn--apply"
          [disabled]="!canApply"
          (click)="applyAndClose()"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</div>
